module.exports = __webpack_public_path__ + "media/newstyle/images/stars_2-7b883e6fa46f26a65a6cf9a781e707c5.svg";